// LOAD-BEARING SIDE-EFFECT IMPORT — do not delete as "unused".
// The hub import warmed the Rematch model cluster; this specifier restores
// that init order. It retires with the Z2 codemod.
import '@/pages/api/scribeAPIV2';

import { type RootState } from '@/store';
import { type UserEHRLaunchProfile } from '@/types';
import { AuthProvider } from '@/utils/auth/persistedAuthProvider';
import { GET_USER_EHR_LAUNCH_PROFILES } from '@heidi/integrations/ehr/contracts';
import { useQueryUserEHRLaunchProfiles as useQueryUserEHRLaunchProfilesCore } from '@heidi/integrations/ehr/data';
import { useSelector } from 'react-redux';
import { useQueryKindeProperties } from '../useQueryKindeProperties';
import { useQueryUserForContext } from '../useQueryUser';

// The launch-profiles read tuple is built in the package core from the caller's authProvider.
export { GET_USER_EHR_LAUNCH_PROFILES };

export function useQueryUserEHRLaunchProfiles<T = UserEHRLaunchProfile[]>(
  select?: (data: UserEHRLaunchProfile[]) => T
) {
  const authProvider = useSelector((state: RootState) => state.auth.authProvider);

  const isAuth0Login =
    authProvider === AuthProvider.AUTH0 || authProvider === AuthProvider.AUTH0_DESKTOP;

  const { data: kindeProperties } = useQueryKindeProperties();
  const { data: user } = useQueryUserForContext((data) => data.kinde_user_id);

  return useQueryUserEHRLaunchProfilesCore({
    authProvider,
    enabled: (isAuth0Login || !!kindeProperties?.region) && !!user,
    select,
  });
}
